import { BILLING_ADDRESS } from 'common/application.const/Licence/MyLicence/expressLetter';
import { BILLING_DETAILS, CORRESPONDENCE_DETAILS } from 'common/application.const/Licence/contactDetails';
import { PAYMENT_LICENCE } from 'common/application.const/Licence/MyLicence/licencePayment';
import { formatDateTime } from 'utils/application.helpers';
import { requestAttachmentListApplication, requestAttachmentListLicence, requestDetails } from 'store/api/application.api';
import { AttachPayload } from 'types/application';
import { convertGBLStatus } from 'utils/formatters/statusConvertGBL';

export const getBillingData = async (licenceDetails: any) => {
    const billingAddress = licenceDetails?.billingAddress?.address ?? {};
    const billingData = {
        [`${BILLING_ADDRESS}-mailingAddress`]: licenceDetails?.billingAddress?.sameAsMailingAddress ?? '',
        [`${BILLING_ADDRESS}-eInvoice`]:
            licenceDetails?.billingAddress?.doYouRequireAnEInvoiceOnVendorsGov ??
            licenceDetails?.billingAddress?.doYouRequireEInvoiceOnVendorsGov ??
            '',
        [`${BILLING_ADDRESS}-Postal`]: billingAddress?.postalCode ?? '',
        [`${BILLING_ADDRESS}-block-house`]: billingAddress?.blockNo ?? '',
        [`${BILLING_ADDRESS}-street`]: billingAddress?.streetName ?? '',
        [`${BILLING_ADDRESS}-building`]: billingAddress?.buildingName ?? '',
        [`${BILLING_ADDRESS}-floor`]: billingAddress?.floor ?? '',
        [`${BILLING_ADDRESS}-unit`]: billingAddress?.unit ?? '',
        [`${BILLING_ADDRESS}-renewal`]: licenceDetails?.billingAddress?.doYouWantYourRenewalBePaidThroughGiro ?? '',
        [`${BILLING_ADDRESS}-imdaArrangement`]: licenceDetails?.billingAddress?.doYouHaveAnExistingGiroArrangementWithImda ?? '',
        [`${BILLING_ADDRESS}-bank`]: licenceDetails?.billingAddress?.bank ?? '',
        [`${BILLING_ADDRESS}-bankNumber`]: licenceDetails?.billingAddress?.bankAccountNumber ?? '',
        [`${BILLING_ADDRESS}-businessUnitNumber`]:
            licenceDetails?.billingAddress?.subBusinessUnit ?? licenceDetails?.billingAddress?.subBusinessUnitNumber ?? ''
    };
    return billingData;
};

export const getContactPersonParticulars = async (licenceDetails: any) => {
    const contactPersonParticulars = {
        [`${CORRESPONDENCE_DETAILS}-sameAsContactPersonParticulars`]:
            licenceDetails?.contactPersonParticulars?.sameAsApplicantParticulars ?? '',
        [`${CORRESPONDENCE_DETAILS}-name`]: licenceDetails?.contactPersonParticulars?.name ?? '',
        [`${CORRESPONDENCE_DETAILS}-mobileNo`]: licenceDetails?.contactPersonParticulars?.mobileNumber ?? '',
        [`${CORRESPONDENCE_DETAILS}-email`]: licenceDetails?.contactPersonParticulars?.email ?? '',
        [`${BILLING_DETAILS}-designation`]: licenceDetails?.contactPersonParticulars?.designation ?? '',
        [`${BILLING_DETAILS}-telNumber`]: licenceDetails?.contactPersonParticulars?.officeTelNumber ?? '',

        [`${CORRESPONDENCE_DETAILS}-buildingName`]: licenceDetails?.contactPersonAddress?.address?.buildingName ?? '-',
        [`${CORRESPONDENCE_DETAILS}-postalCode`]: licenceDetails?.contactPersonAddress?.address?.postalCode ?? '-',
        [`${CORRESPONDENCE_DETAILS}-streetName`]: licenceDetails?.contactPersonAddress?.address?.streetName ?? '-',
        [`${CORRESPONDENCE_DETAILS}-blockNo`]: licenceDetails?.contactPersonAddress?.address?.blockNo ?? '-',
        [`${CORRESPONDENCE_DETAILS}-floor`]: licenceDetails?.contactPersonAddress?.address?.floor ?? '-',
        [`${CORRESPONDENCE_DETAILS}-unit`]: licenceDetails?.contactPersonAddress?.address?.unit ?? '-'
    };
    return contactPersonParticulars;
};

export const getBillingPersonParticulars = async (licenceDetails: any) => {
    const billingPersonParticulars = {
        [`${BILLING_DETAILS}-sameAsContactPersonParticulars`]:
            licenceDetails?.billingPersonParticulars?.sameAsContactPersonParticulars ??
            licenceDetails?.billingPersonParticulars?.sameAsContactPerson ??
            '',
        [`${BILLING_DETAILS}-name`]: licenceDetails?.billingPersonParticulars?.name ?? '',
        [`${BILLING_DETAILS}-mobileNo`]: licenceDetails?.billingPersonParticulars?.mobileNumber ?? '',
        [`${BILLING_DETAILS}-email`]: licenceDetails?.billingPersonParticulars?.email ?? '',
        [`${BILLING_DETAILS}-designation`]: licenceDetails?.billingPersonParticulars?.designation ?? '',
        [`${BILLING_DETAILS}-telNumber`]: licenceDetails?.billingPersonParticulars?.officeTelNumber ?? ''
    };
    return billingPersonParticulars;
};

export const getPaymentDetails = async (
    licenceDetails: any,
    transactionType: any,
    content: any,
    customExpDate: any,
    cancellationDate: any
) => {
    let licence;
    const billingAddress = licenceDetails?.billingAddress?.address ?? {};
    licence = {
        id: 'payment-licence',
        formID: 'payment-licence',
        hasError: true,
        title: 'Payment Setup',
        values: {
            [`${BILLING_DETAILS}-name`]: licenceDetails?.billingPersonParticulars?.name ?? '',
            [`${BILLING_DETAILS}-mobileNo`]: licenceDetails?.billingPersonParticulars?.mobileNumber ?? '',
            [`${BILLING_DETAILS}-email`]: licenceDetails?.billingPersonParticulars?.email ?? '',
            [`${BILLING_DETAILS}-designation`]: licenceDetails?.billingPersonParticulars?.designation ?? '',
            [`${BILLING_DETAILS}-telNumber`]: licenceDetails?.billingPersonParticulars?.officeTelNumber ?? '',
            [`${BILLING_DETAILS}-contactNumber`]: licenceDetails?.billingPersonParticulars?.ContactNumber ?? '',
            [`${BILLING_DETAILS}-licenceName`]: content?.licenceName ?? '',

            [`${BILLING_ADDRESS}-address-type`]: billingAddress?.addressType ?? 'Singapore',
            [`${BILLING_ADDRESS}-foreign-address-line-one`]: billingAddress?.foreignAddress1 ?? '',
            [`${BILLING_ADDRESS}-foreign-address-line-two`]: billingAddress?.foreignAddress2 ?? '',
            [`${BILLING_ADDRESS}-foreign-address-line-three`]: billingAddress?.foreignAddress3 ?? '',
            [`${BILLING_ADDRESS}-city`]: (billingAddress?.City || billingAddress?.city) ?? '',
            [`${BILLING_ADDRESS}-state`]: (billingAddress?.State || billingAddress?.state) ?? '',
            [`${BILLING_ADDRESS}-zip-code`]: (billingAddress?.ZipCode || billingAddress?.zipCode) ?? '',
            [`${BILLING_ADDRESS}-country`]: (billingAddress?.Country || billingAddress?.country) ?? '',

            [`${BILLING_ADDRESS}-Postal`]: billingAddress?.postalCode ?? '',
            [`${BILLING_ADDRESS}-block-house`]: billingAddress?.blockNo ?? '',
            [`${BILLING_ADDRESS}-street`]: billingAddress?.streetName ?? '',
            [`${BILLING_ADDRESS}-building`]: billingAddress?.buildingName ?? '',
            [`${BILLING_ADDRESS}-floor`]: billingAddress?.floor ?? '',
            [`${BILLING_ADDRESS}-unit`]: billingAddress?.unit ?? '',
            [`${BILLING_ADDRESS}-renewal`]: licenceDetails?.billingAddress?.doYouWantYourRenewalBePaidThroughGiro ?? '',
            [`${BILLING_ADDRESS}-imdaArrangement`]: licenceDetails?.billingAddress?.doYouHaveAnExistingGiroArrangementWithImda ?? '',
            [`${BILLING_ADDRESS}-bank`]: licenceDetails?.billingAddress?.bank ?? '',
            [`${BILLING_ADDRESS}-bankNumber`]: licenceDetails?.billingAddress?.bankAccountNumber ?? '',

            [`${PAYMENT_LICENCE}-doYouRequireEInvoiceOnVendorsGov`]:
                licenceDetails.billingAddress?.doYouRequireEInvoiceOnVendorsGov ??
                licenceDetails.billingAddress?.doYouRequireAnEInvoiceOnVendorsGov ??
                '',
            [`${PAYMENT_LICENCE}-subBusinessUnitCode`]:
                licenceDetails.billingAddress?.subBusinessUnit ?? licenceDetails.billingAddress?.subBusinessUnitNumber ?? '',
            [`${PAYMENT_LICENCE}-doYouWantYourRenewalBePaidThroughGiro`]:
                licenceDetails.billingAddress?.doYouWantYourRenewalBePaidThroughGiro ?? '',
            [`${PAYMENT_LICENCE}-doYouHaveAnExistingGiroArrangementWithImda`]:
                licenceDetails.billingAddress?.doYouHaveAnExistingGiroArrangementWithImda ?? '',
            [`${PAYMENT_LICENCE}-bank`]: licenceDetails.billingAddress?.bank ?? '',
            [`${PAYMENT_LICENCE}-bankAccountNumber`]: licenceDetails.billingAddress?.bankAccountNumber ?? '',

            CustomerStatus: transactionType === 'Cancel' ? 'Processing' : content.BusinessStatus ?? '',
            BusinessStatus: transactionType === 'Cancel' ? 'Processing' : content.BusinessStatus ?? '',
            CaseRefKey: content.CaseRefKey || '',
            transactionType: transactionType || '',
            ExpirationDate: customExpDate || '',
            EffectiveCancellationDate: cancellationDate || '',
            CancellationReason:
                content?.LICCancellation?.CancellationReason || licenceDetails?.cancellationInformation?.cancellationReason || ''
        }
    };
    return licence;
};

export const getBillingDetails = async (
    licenceDetails: any,
    transactionType: any,
    content: any,
    customExpDate: any,
    cancellationDate: any
) => {
    let licence;
    const billingAddress = licenceDetails?.billingAddress?.address ?? {};
    licence = {
        id: 'billing-details',
        formID: 'billing-details',
        hasError: true,
        title: 'Billing Details',
        values: {
            [`${BILLING_DETAILS}-name`]: licenceDetails?.billingPersonParticulars?.name ?? '',
            [`${BILLING_DETAILS}-mobileNo`]: licenceDetails?.billingPersonParticulars?.mobileNumber ?? '',
            [`${BILLING_DETAILS}-email`]: licenceDetails?.billingPersonParticulars?.email ?? '',
            [`${BILLING_DETAILS}-designation`]: licenceDetails?.billingPersonParticulars?.designation ?? '',
            [`${BILLING_DETAILS}-telNumber`]: licenceDetails?.billingPersonParticulars?.officeTelNumber ?? '',
            [`${BILLING_DETAILS}-contactNumber`]: licenceDetails?.billingPersonParticulars?.ContactNumber ?? '',
            [`${BILLING_DETAILS}-licenceName`]: content?.licenceName ?? '',

            [`${BILLING_ADDRESS}-address-type`]: billingAddress?.addressType ?? 'Singapore',
            [`${BILLING_ADDRESS}-foreign-address-line-one`]: billingAddress?.foreignAddress1 ?? '',
            [`${BILLING_ADDRESS}-foreign-address-line-two`]: billingAddress?.foreignAddress2 ?? '',
            [`${BILLING_ADDRESS}-foreign-address-line-three`]: billingAddress?.foreignAddress3 ?? '',
            [`${BILLING_ADDRESS}-city`]: (billingAddress?.City || billingAddress?.city) ?? '',
            [`${BILLING_ADDRESS}-state`]: (billingAddress?.State || billingAddress?.state) ?? '',
            [`${BILLING_ADDRESS}-zip-code`]: (billingAddress?.ZipCode || billingAddress?.zipCode) ?? '',
            [`${BILLING_ADDRESS}-country`]: (billingAddress?.Country || billingAddress?.country) ?? '',

            [`${BILLING_ADDRESS}-Postal`]: billingAddress?.postalCode ?? '',
            [`${BILLING_ADDRESS}-block-house`]: billingAddress?.blockNo ?? '',
            [`${BILLING_ADDRESS}-street`]: billingAddress?.streetName ?? '',
            [`${BILLING_ADDRESS}-building`]: billingAddress?.buildingName ?? '',
            [`${BILLING_ADDRESS}-floor`]: billingAddress?.floor ?? '',
            [`${BILLING_ADDRESS}-unit`]: billingAddress?.unit ?? '',
            [`${BILLING_ADDRESS}-renewal`]: licenceDetails?.billingAddress?.doYouWantYourRenewalBePaidThroughGiro ?? '',
            [`${BILLING_ADDRESS}-imdaArrangement`]: licenceDetails?.billingAddress?.doYouHaveAnExistingGiroArrangementWithImda ?? '',
            [`${BILLING_ADDRESS}-bank`]: licenceDetails?.billingAddress?.bank ?? '',
            [`${BILLING_ADDRESS}-bankNumber`]: licenceDetails?.billingAddress?.bankAccountNumber ?? '',

            [`${PAYMENT_LICENCE}-doYouRequireEInvoiceOnVendorsGov`]:
                licenceDetails.billingAddress?.doYouRequireEInvoiceOnVendorsGov ??
                licenceDetails.billingAddress?.doYouRequireAnEInvoiceOnVendorsGov ??
                '',
            [`${PAYMENT_LICENCE}-subBusinessUnitCode`]:
                licenceDetails.billingAddress?.subBusinessUnit ?? licenceDetails.billingAddress?.subBusinessUnitNumber ?? '',
            [`${PAYMENT_LICENCE}-doYouWantYourRenewalBePaidThroughGiro`]:
                licenceDetails.billingAddress?.doYouWantYourRenewalBePaidThroughGiro ?? '',
            [`${PAYMENT_LICENCE}-doYouHaveAnExistingGiroArrangementWithImda`]:
                licenceDetails.billingAddress?.doYouHaveAnExistingGiroArrangementWithImda ?? '',
            [`${PAYMENT_LICENCE}-bank`]: licenceDetails.billingAddress?.bank ?? '',
            [`${PAYMENT_LICENCE}-bankAccountNumber`]: licenceDetails.billingAddress?.bankAccountNumber ?? '',

            CustomerStatus: transactionType === 'Cancel' ? 'Processing' : content.BusinessStatus ?? '',
            BusinessStatus: transactionType === 'Cancel' ? 'Processing' : content.BusinessStatus ?? '',
            CaseRefKey: content.CaseRefKey || '',
            transactionType: transactionType || '',
            ExpirationDate: customExpDate || '',
            EffectiveCancellationDate: cancellationDate || '',
            CancellationReason:
                content?.LICCancellation?.CancellationReason || licenceDetails?.cancellationInformation?.cancellationReason || ''
        }
    };

    return licence;
};

export const getSummaryDetails = async (licenceDetails: any, isAEL: any, content: any, general: any) => {
    let licence;
    const expiryDate = content?.BusinessStatus === 'Cancelled' ? 'NA' : formatDateTime(content?.ExpirationDate ?? '', true);
    licence = {
        id: 'summary',
        formID: isAEL ? 'summary-ael' : 'summary',
        hasError: true,
        values: {
            [`summary-transactionType`]: (general.transactionType ?? '').charAt(0).toUpperCase() + (general.transactionType ?? '').slice(1),
            [`summary-title`]: licenceDetails?.detailsOfTheArtsEntertainment?.titleOfEvent ?? '',
            [`summary-application-name`]: general?.licenceName ?? '',
            [`summary-application-category`]: licenceDetails?.aircraftStationInformation?.aircraftCategory ?? '',
            [`summary-application-number`]: general.applicationNumber ?? '',
            [`summary-application-businessStatus`]: convertGBLStatus(general?.licenceName, content?.BusinessStatus ?? '') ?? content.status,
            [`summary-application-submission`]: formatDateTime(content.ApplicationDate ?? '', true) ?? '',
            [`summary-gbl-id`]: general?.applicationNumber ?? '',
            [`summary-id`]: content?.LinkedLicence ?? content?.caseid ?? '',
            [`summary-status`]: content.BusinessStatus ?? content?.CustomerStatus,
            [`summary-start-date`]: formatDateTime(content?.StartDate ?? '', true),
            [`summary-expiry-date`]: expiryDate,
            [`summary-submission-date`]: formatDateTime(content?.pxCreateDateTime ?? '', true),
            caseID: content?.LinkedLicence ?? content?.caseid ?? ''
        }
    };
    return licence;
};

export const getLicenceDownload = async (caseTypeID: any) => {
    const resp = (caseTypeID ? await requestAttachmentListLicence(caseTypeID) : []) as AttachPayload[];

    const files = resp?.map((attachment: any) => {
        const createdDate = formatDateTime(attachment.pxCreateDateTime ?? '', true);
        return {
            id: 'licenceFile',
            data: [`${attachment.fileName}`, `${attachment.pyCategory}`, `${createdDate}`, 'Download'],
            extension: attachment.fileName.split('.')[1],
            fileName: attachment.fileName,
            categoryName: attachment.pyCategory,
            createTime: attachment.pxCreateDateTime,
            name: attachment.fileName.split('.')[0],
            links: {
                download: {
                    rel: 'self',
                    href: attachment.DownloadLink,
                    title: 'Download the attachment',
                    type: 'GET'
                }
            },
            ID: attachment.DownloadLink.split('/')[2],
            category: attachment.pyCategory
        };
    });
    const licenceDownload = {
        id: 'licence_download',
        formID: 'licence_download',
        hasError: true,
        values: { files }
    };
    return [licenceDownload];
};

export const getApplicationDownload = async (caseTypeID: any, licenceName?: string) => {
    const uploadedFiles = (caseTypeID ? await requestAttachmentListApplication(caseTypeID) : []) as AttachPayload[];

    let licenceDetails: any;

    if (licenceName === 'Technical Trial (without use of Frequency)') {
        licenceDetails = await requestDetails(caseTypeID);
    }

    const categoryFileList = ['e-Licence', 'Receipt', 'Invoice', 'SDOC', 'ApprovalLetter', 'Annex', 'e-Letter', 'TermsConditions', 'Notification', 'SubmissionReceipt'];
    const TFLicenceCategoryFileList = ['e-Licence', 'Receipt', 'Invoice', 'SDOC', 'ApprovalLetter', 'Annex', 'TermsConditions', 'Notification', 'SubmissionReceipt'];

    const categoryFileListMap =
        licenceName === 'Technical Trial (without use of Frequency)' &&
        (licenceDetails?.content?.BusinessStatus === 'Withdrawn' || licenceDetails?.content?.BusinessStatus === 'Rejected')
            ? TFLicenceCategoryFileList
            : categoryFileList;

    const files =
        uploadedFiles
            ?.filter((value: any) => categoryFileListMap.includes(value?.pyCategory))
            ?.map((value) => {
                const createdDate = formatDateTime(value.createTime ?? '', true);
                return {
                    id: 'licenceFile',
                    data: [`${value.fileName}`, `${value.pyCategory}`, `${createdDate}`, 'Download'],
                    ...value
                };
            }) ?? {};
    const licenceDownload = {
        id: 'licence_download',
        formID: 'licence_download',
        hasError: true,
        values: { files }
    };
    return [licenceDownload];
};

const commonPayload = {
    getBillingData,
    getContactPersonParticulars,
    getBillingPersonParticulars,
    getPaymentDetails,
    getBillingDetails,
    getLicenceDownload,
    getApplicationDownload,
    getSummaryDetails
};

export default commonPayload;
